<script setup lang="ts">
import DraggableCard from '@/components/Cards/DraggableCard.vue'
import DeviceDetectionsCount from '@/components/DeviceComponents/Card/DeviceDetectionsCount.vue'
import { EHubProvider, type DeviceHubCard } from '@/types/enum/HubProviderEnum'
import type { DetectionModel } from '@/types/models/DetectionModel'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import { DeviceCard } from '@rfc/rfc-components-library'
import { EProviders, type DrawerProviderType } from '@rfc/rfc-components-library/types'
import { type Position } from '@vueuse/core'
import { inject, provide } from 'vue'

const { deviceDrawer } = inject<DrawerProviderType>(EProviders.DRAWER, {})

type Props = {
    device: AssociatedDeviceModel
    detections?: DetectionModel[]
    eventId?: number
    checkpointId?: number
}
defineProps<Props>()

type Emits = {
    (e: 'dragStart', device: AssociatedDeviceModel): void
    (e: 'dragEnd', position?: Position): void
    (e: 'click', device: AssociatedDeviceModel): void
}
defineEmits<Emits>()

provide<DeviceHubCard>(EHubProvider.DEVICES_HUB_CARD, { hideAssociated: true })
</script>

<template>
    <DraggableCard
        @dragStart="$emit('dragStart', device)"
        @dragEnd="$emit('dragEnd', $event)"
        class="device-cp-drag-card">
        <template #default="props">
            <DeviceCard
                class="device-card fit-content h-full"
                :data="device as any"
                :detections="detections ?? []"
                @click.stop="deviceDrawer?.updateDeviceId?.(device?.device_id ?? device?.id)"
                v-bind="props">
                <template #content>
                    <DeviceDetectionsCount
                        v-if="eventId && checkpointId"
                        :eventId="eventId"
                        :checkpointId="checkpointId"
                        :deviceId="device?.device_id ?? device?.id" />
                </template>
            </DeviceCard>
        </template>
    </DraggableCard>
</template>

<style scoped lang="scss">
.device-card {
    box-shadow: 1px 1px 7px $grey-shadow;
    &:hover {
        box-shadow: 1px 1px 7px rgb(252, 127, 3);
        transition: ease-in-out 0.2s;
    }
}
</style>
